import { render } from "./QualificationView.vue?vue&type=template&id=20737131&scoped=true"
import script from "./QualificationView.vue?vue&type=script&lang=js"
export * from "./QualificationView.vue?vue&type=script&lang=js"

import "./QualificationView.vue?vue&type=style&index=0&id=20737131&scoped=true&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20737131"]])

export default __exports__